'use client';

import { c as _c } from "react/compiler-runtime";
import { DropdownMenu } from '@common/components';
import { Pagination } from '@common/components/molecule/Pagination';
import { Fragment } from 'react';
import { SearchCategoryAdSlot } from '@/app/_components/ads';
import type { PolicySortOption } from '../../_hooks/usePolicyFilter';
import { EMPTY_SEARCH_RESULT_MESSAGE, PAGE_SIZE } from '../../constants';
import type { PolicyData } from './SearchPolicyCard';
import { SearchPolicyCard } from './SearchPolicyCard';
import { SearchPolicyCardSkeletonList } from './SearchPolicyCardSkeleton';
const SORT_LABEL: Record<PolicySortOption, string> = {
  SCORE: '정확도순',
  LATEST: '최신순'
};
const SORT_OPTIONS = (Object.keys(SORT_LABEL) as PolicySortOption[]).map(value => ({
  value,
  label: SORT_LABEL[value]
}));
interface PolicyResultListProps {
  policies: PolicyData[];
  totalCount: number;
  sort: PolicySortOption;
  onSortChange: (sort: PolicySortOption) => void;
  page: number;
  totalPages: number;
  onPageChange: (page: number) => void;
  isLoading?: boolean;
  emptyMessage?: string;
}
export function PolicyResultList(t0) {
  const $ = _c(23);
  const {
    policies,
    totalCount,
    sort,
    onSortChange,
    page,
    totalPages,
    onPageChange,
    isLoading: t1,
    emptyMessage: t2
  } = t0;
  const isLoading = t1 === undefined ? false : t1;
  const emptyMessage = t2 === undefined ? EMPTY_SEARCH_RESULT_MESSAGE : t2;
  let t3;
  if ($[0] !== totalCount) {
    t3 = totalCount.toLocaleString();
    $[0] = totalCount;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== t3) {
    t4 = <p className="font-700 text-Gray-black typo-body4 mobile-tablet:font-500">전체 {t3}건</p>;
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== onSortChange || $[5] !== sort) {
    t5 = <DropdownMenu type="text" align="end" options={SORT_OPTIONS} value={sort} onChange={onSortChange} contentClassName="min-w-150" />;
    $[4] = onSortChange;
    $[5] = sort;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t4 || $[8] !== t5) {
    t6 = <div className="flex items-center justify-between mobile-tablet:px-20">{t4}{t5}</div>;
    $[7] = t4;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== emptyMessage || $[11] !== isLoading || $[12] !== policies) {
    t7 = <div className="flex flex-1 flex-col">{isLoading ? <SearchPolicyCardSkeletonList count={PAGE_SIZE} /> : policies.length > 0 ? <div className="flex flex-col gap-12 pb-20 mobile-tablet:gap-0 mobile-tablet:pb-0">{policies.map((policy, idx) => <Fragment key={policy.id}><SearchCategoryAdSlot placement="search-policy" position={idx + 1} listLength={policies.length} /><SearchPolicyCard policy={policy} /></Fragment>)}</div> : <div className="flex-1 py-80 flex-center"><p className="text-Gray-550 typo-body4">{emptyMessage}</p></div>}</div>;
    $[10] = emptyMessage;
    $[11] = isLoading;
    $[12] = policies;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== onPageChange || $[15] !== page || $[16] !== totalCount || $[17] !== totalPages) {
    t8 = totalPages > 1 && <Pagination totalCount={totalCount} currentPage={page} size={PAGE_SIZE} onMovePage={onPageChange} perButtonCount={5} className="my-0 pb-40" />;
    $[14] = onPageChange;
    $[15] = page;
    $[16] = totalCount;
    $[17] = totalPages;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== t6 || $[20] !== t7 || $[21] !== t8) {
    t9 = <div className="flex min-w-0 flex-1 flex-col">{t6}{t7}{t8}</div>;
    $[19] = t6;
    $[20] = t7;
    $[21] = t8;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  return t9;
}